/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Newsletter_DescInputs */

const en_directory_home_newsletter_desc = /** @type {(inputs: Directory_Home_Newsletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join thousands of builders. New tools and picks, every week.`)
};

const zh_directory_home_newsletter_desc = /** @type {(inputs: Directory_Home_Newsletter_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入数千位 builder，每周获取新工具与精选推荐。`)
};

/**
* | output |
* | --- |
* | "Join thousands of builders. New tools and picks, every week." |
*
* @param {Directory_Home_Newsletter_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_newsletter_desc = /** @type {((inputs?: Directory_Home_Newsletter_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Newsletter_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_newsletter_desc(inputs)
	return zh_directory_home_newsletter_desc(inputs)
});
export { directory_home_newsletter_desc as "directory.home.newsletter_desc" }